import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { PropTableValues } from "../../../../src/components";
import { Label } from '@primer/react';
import { Link } from 'gatsby';
import ComponentLayout from "../../../../src/layouts/component-layout";
import * as React from 'react';
export default {
  InlineCode,
  PropTableValues,
  Label,
  Link,
  ComponentLayout,
  React
};